<template>
  <div class="inputLabel">
    <span class="mr-1">{{ labelName }}</span>
    <v-chip v-if="required" x-small label outlined color="error"> 必須 </v-chip>
    <v-chip v-else x-small label outlined> 任意 </v-chip>
  </div>
</template>

<script>
export default {
  props: {
    labelName: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style lang="sass">
.inputLabel
  display: flex
  align-items: center
</style>
